import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

export const useBackofficeTable = ({ tableKey, columns }) => {
  const columnsList = columns.map(({ headerKey, accessorKey, ...column }) => ({
    ...column,
    header: headerKey ? <FormattedMessage id={headerKey} /> : null,
    id: headerKey || column.id,
    enableSorting: Boolean(accessorKey),
    accessorKey,
  }));

  const savedTableState = JSON.parse(localStorage.getItem(tableKey));

  const [columnVisibility, setColumnVisibility] = useState(savedTableState?.visibility || {});

  const savedColOrder = JSON.parse(localStorage.getItem(tableKey))?.order;
  const defaultColOrder = columnsList.map(column => column.id);

  const [columnOrder, setColumnOrder] = useState(
    Array.isArray(savedColOrder) && savedColOrder.length ? savedColOrder : defaultColOrder
  );

  const savedColSizes = savedTableState?.colSizes || {};

  useEffect(() => {
    localStorage.setItem(tableKey, JSON.stringify({ ...savedTableState, visibility: columnVisibility }));
  }, [columnVisibility]);

  useEffect(() => {
    localStorage.setItem(tableKey, JSON.stringify({ ...savedTableState, order: columnOrder }));
  }, [columnOrder]);

  return {
    columnsList,
    savedColSizes,
    columnOrder,
    defaultColOrder,
    setColumnOrder,
    columnVisibility,
    setColumnVisibility,
  };
};
